export const CHANGE_LOADING = 'CHANGE_LOADING'
export const CHANGE_SUBMITTING_POINT_A = 'CHANGE_SUBMITTING_POINT_A'
export const CHANGE_SUBMITTING_POINT_B = 'CHANGE_SUBMITTING_POINT_B'
export const CHANGE_LOADING_ANALYSIS = 'CHANGE_LOADING_ANALYSIS'
export const CHANGE_POLLING_ANALYSIS = 'CHANGE_POLLING_ANALYSIS'

export const INCREMENT_CLOSE_ATTEMPTS = 'INCREMENT_CLOSE_ATTEMPTS'
export const RESET_CLOSE_ATTEMPTS = 'RESET_CLOSE_ATTEMPTS'

export const SET_POINT_A_DATA = 'SET_POINT_A_DATA'
export const SET_POINT_B_DATA = 'SET_POINT_B_DATA'
export const SET_POINT_A_COMPLETED = 'SET_POINT_A_COMPLETED'
export const SET_POINT_B_COMPLETED = 'SET_POINT_B_COMPLETED'
export const SET_ANALYSIS = 'SET_ANALYSIS'
export const SET_ERROR = 'SET_ERROR'
export const RESET_STATE = 'RESET_STATE'
export const SET_EXPECTATION_OPTIONS = 'SET_EXPECTATION_OPTIONS'
export const SET_EXPECTATION_LABELS = 'SET_EXPECTATION_LABELS'
